import { useState, useEffect, useRef } from "react";
import cn from "classnames";
import Button from "../../../../audi-ui-components/Button";
import {
  requestTypes,
} from "./CVOConstants";

const nextStepBreakpoint = 450;

const NextStep = ({ children, className, image, title }) => {
  const wrapperRef = useRef(null);
  const [isLarge, setIsLarge] = useState(false);
  const update = (entries) => {
    let w = entries[0].contentRect.width;
    setIsLarge(w > nextStepBreakpoint);
  };
  useEffect(() => {
    const obs = new ResizeObserver(update);
    if (wrapperRef.current) {
      obs.observe(wrapperRef.current);
    }
    return () => {
      obs.disconnect();
    };
  }, []);
  return (
    <div ref={wrapperRef} className={cn("next-step", className, {"overbp": isLarge, "underbp": !isLarge})}>
      <img src={image} alt="" />
      <div className="next-step__inner">
        {title && <p className="next-step__title mb-4">{title}</p>}
        {children}
      </div>
    </div>
  )
}

const NextSteps = ({ requestType }) => {
  if (requestType === requestTypes.NO_LONGER_OWN) {
    return (
      <div className="row pb-5">
        <div className="col-12 col-small-6">
          <NextStep className="large" image={`${process.env.PUBLIC_PATH}assets/A243841_large.jpg`} title="Searching for an upgrade?">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/model-range/rs-range/" target="_blank" rel="nofollow noreferrer">
              Discover the RS Range
            </Button>
          </NextStep>
        </div>
        <div className="col-12 col-small-6">
          <NextStep className="large" image={`${process.env.PUBLIC_PATH}assets/AUDI0223_Q5_2024_7163_R1.jpg`} title="Explore the latest Audi models">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/model-range/" target="_blank" rel="nofollow noreferrer">
              <span className="btn-label-large">Explore now</span>
              <span className="btn-label-small">Explore the latest Audi models</span>
            </Button>
          </NextStep>
        </div>
      </div>
    );
  }

  if (requestType === requestTypes.WRITTEN_OFF) {
    return (
      <div className="row pb-5">
        <div className="col-12 col-small-6">
          <NextStep image={`${process.env.PUBLIC_PATH}assets/AUDI0223_Q5_2024_7163_R1.jpg`}>
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/offers/" target="_blank" rel="nofollow noreferrer">
              View our latest offers
            </Button>
          </NextStep>
        </div>
        <div className="col-12 col-small-6">
          <NextStep image={`${process.env.PUBLIC_PATH}assets/audi-insurance.jpg`}>
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/financial-services/insurance/" target="_blank" rel="nofollow noreferrer">
              Explore Audi Insurance
            </Button>
          </NextStep>
        </div>
      </div>
    );
  }
  return null;
};

export default NextSteps;
